import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IInviteBusinessToAggregatorNetworkRequest {
  emails: string[];
}

interface IInviteBusinessToAggregatorNetworkResponse {
  status?: boolean;
  message?: string;
  data?: {
    invitesSent?: number;
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IInviteBusinessToAggregatorNetworkResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const inviteBusinessToAggregatorNetworkAsync = createAsyncThunk(
  'aggregator/inviteBusinessToNetwork',
  async (
    values: IInviteBusinessToAggregatorNetworkRequest,
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } =
        await api.post<IInviteBusinessToAggregatorNetworkResponse>(
          '/aggregator/business/invite',
          values,
          config
        );

      return data;
    } catch (err) {
      const error =
        err as AxiosError<IInviteBusinessToAggregatorNetworkResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const aggregatorInvitationSlice = createSlice({
  name: 'aggregator/addBusiness',
  initialState,
  reducers: {
    resetInviteBusinessToAggregatorNetwork(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(inviteBusinessToAggregatorNetworkAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(
        inviteBusinessToAggregatorNetworkAsync.fulfilled,
        (state, action) => {
          state.status = 'success';
          state.value = action.payload;
        }
      )
      .addCase(
        inviteBusinessToAggregatorNetworkAsync.rejected,
        (state, action) => {
          state.status = 'failed';
          state.value =
            action.payload as IInviteBusinessToAggregatorNetworkResponse;
          state.error = action.error.message;
        }
      );
  },
});

export const { resetInviteBusinessToAggregatorNetwork } =
  aggregatorInvitationSlice.actions;

export default aggregatorInvitationSlice.reducer;
